module.exports = __webpack_public_path__ + "static/media/0015.798065ea.svg";